import React, { useEffect, useState } from "react";
import {
  Alert,
  FormControl,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useCallContext } from "../context/CallContext";

const CARD = {
  p: 2.5,
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
};

/**
 * Preferência de atendimento de voz: automático (híbrido), sempre softphone, sempre celular.
 */
export default function VoiceAnswerModeProfileSection() {
  const { setVoiceAnswerMode } = useCallContext() || {};
  const [mode, setMode] = useState("auto");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("xpro_voice_answer_mode");
      const m = String(raw || "").trim().toLowerCase();
      if (m === "softphone" || m === "pstn" || m === "auto") setMode(m);
    } catch (_) {
      /* ignore */
    }
  }, []);

  const onChange = (e) => {
    const next = String(e.target.value || "auto");
    setMode(next);
    setVoiceAnswerMode?.(next);
    setSaved(true);
    window.setTimeout(() => setSaved(false), 2500);
  };

  return (
    <Paper sx={CARD}>
      <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 0.5 }}>
        Como receber ligações
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        No computador (navegador, app do Chrome ou escritório virtual) a ligação toca mesmo
        com a janela em segundo plano ou com várias telas abertas. No celular, o softphone
        só toca com o app em primeiro plano — no modo automático, aí ligamos para o celular
        do perfil.
      </Typography>
      <FormControl component="fieldset">
        <FormLabel component="legend" sx={{ mb: 1, fontSize: "0.85rem" }}>
          Preferência
        </FormLabel>
        <RadioGroup value={mode} onChange={onChange}>
          <FormControlLabel
            value="auto"
            control={<Radio size="small" />}
            label="Automático (híbrido) — toca no app se você estiver logado no computador; no celular em segundo plano, liga para o celular do perfil"
          />
          <FormControlLabel
            value="softphone"
            control={<Radio size="small" />}
            label="Sempre softphone no app (sem ligar no celular)"
          />
          <FormControlLabel
            value="pstn"
            control={<Radio size="small" />}
            label="Sempre celular (áudio na linha móvel)"
          />
        </RadioGroup>
      </FormControl>
      {saved ? (
        <Alert severity="success" sx={{ mt: 1.5 }}>
          Preferência salva neste aparelho.
        </Alert>
      ) : null}
    </Paper>
  );
}
